import analytics from 'app/analytics';
import ContactsForm from 'components/ContactsForm';
import React, { useEffect } from 'react';
import CloseIcon from 'svg/CloseIcon';
import { MODALS } from '../../consts';
import useStyles from './styles';

interface IProps {
  onClose: () => void;
}

const ContactSalesModal: React.FC<IProps> = (props) => {
  const { onClose } = props;
  const classes = useStyles();

  useEffect(() => {
    analytics.sendEvent('MODAL_SHOW', { modalId: MODALS.CONTACT_SALES });

    return () => {
      analytics.sendEvent('MODAL_HIDE', { modalId: MODALS.CONTACT_SALES });
    };
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <p className={classes.titleLabel}>
          Contact sales
        </p>

        <button type="button" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </button>
      </div>
      <div className={classes.form}>
        <ContactsForm />
      </div>
    </div>
  );
};

export default ContactSalesModal;
